import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { uuid, TUuidCodec } from "../../../shared/src/codecs/types/uuid";
import { array, TArrayCodec } from "../../../shared/src/codecs/types/array";
import { ProofOfFundsDocument2, TProofOfFundsDocument2Codec } from "../ProofOfFundsDocument";

type TGetProofOfFundsDocumentsInputCodec = TRequiredCodec<{
    enquiry_id: TUuidCodec;
}>;

type TGetProofOfFundsDocumentsOutputCodec = TRequiredCodec<{
    documents: TArrayCodec<TProofOfFundsDocument2Codec>;
}>;

export const GetProofOfFundsDocumentsFormIO: TFormIOCodec<
    TGetProofOfFundsDocumentsInputCodec,
    TGetProofOfFundsDocumentsOutputCodec
> = formIO(
    required({
        enquiry_id: uuid(),
    }),
    required({
        documents: array(ProofOfFundsDocument2),
    }),
);

export type TGetProofOfFundsDocumentsFormIOCodec = typeof GetProofOfFundsDocumentsFormIO;
export type TGetProofOfFundsDocumentsFormIO = TTypeOfCodec<TGetProofOfFundsDocumentsFormIOCodec>;
